import React from 'react';

interface QuantityControlProps {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  disabled?: boolean;
  minValue?: number;
  maxValue?: number;
  className?: string;
}

const QuantityControl = ({
  value,
  onIncrement,
  onDecrement,
  disabled = false,
  minValue = 1,
  maxValue,
  className = '',
}: QuantityControlProps) => {
  const isDecrementDisabled = disabled || value <= minValue;
  const isIncrementDisabled =
    disabled || (maxValue !== undefined && value >= maxValue);

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <button
        onClick={onDecrement}
        disabled={isDecrementDisabled}
        className="w-8 h-8 p-0 flex items-center justify-center border border-gray-300 rounded text-sm bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        -
      </button>

      <span className="min-w-[30px] text-center font-medium text-sm px-1">
        {value}
      </span>

      <button
        onClick={onIncrement}
        disabled={isIncrementDisabled}
        className="w-8 h-8 p-0 flex items-center justify-center border border-gray-300 rounded text-sm bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        +
      </button>
    </div>
  );
};

export default QuantityControl;
